<template>
  <v-row class="py-3">
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("source-adapter-messages.id") }}:</b>
        {{ sourceAdapterMessage.id }}
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("source-adapter-messages.source-adapter") }}: </b>
        <router-link
          class="link black--text"
          :to="{
            name: 'source-adapter',
            params: {
              project_id: $route.params.project_id,
              id: sourceAdapterMessage.source_adapter_id
            }
          }"
          >{{ sourceAdapterMessage.source_adapter_id }}</router-link
        >
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("source-adapter-messages.sender") }}:</b>
        {{ sourceAdapterMessage.sender }}
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b> {{ $t("source-adapter-messages.receive-time") }} : </b>
        {{
          sourceAdapterMessage.receive_time &&
            $dateTime(
              new Date(sourceAdapterMessage.receive_time),
              "long",
              "",
              project.timezone
            )
        }}
      </p>
    </v-col>

    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("source-adapter-messages.event") }}:</b>
        {{ sourceAdapterMessage.event }}
      </p>
    </v-col>
    <v-col cols="12" sm="4">
      <p>
        <b>{{ $t("source-adapter-messages.method") }}:</b>
        {{ sourceAdapterMessage.method }}
      </p>
    </v-col>
    <v-col cols="12" sm="12">
      <p>
        <b>{{ $t("source-adapter-messages.headers") }}:</b>
        <codemirror
          :value="headers"
          :options="options"
          class="test"
        ></codemirror>
      </p>
    </v-col>
  </v-row>
</template>

<script>
import { codemirror } from "vue-codemirror";
export default {
  name: "GeneralInformationTransmission",
  components: { codemirror },
  data: () => ({
    options: {
      lineNumbers: true,
      foldGutter: true,
      gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
      readOnly: true,
      mode: "application/json"
    }
  }),
  computed: {
    sourceAdapterMessage: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/sourceAdapterMessageStore/getItem"
        ];
      }
    },
    project() {
      return this.$store.getters["projectStore/getItem"];
    },
    headers() {
      return (
        this.sourceAdapterMessage.headers &&
        JSON.stringify(JSON.parse(this.sourceAdapterMessage.headers), null, 4)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.test {
  width: 100%;
}
.link {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
